import { useCallback, useEffect } from 'react';
import useStores from 'shared/hooks/use-stores';
import { useCountdownTimer } from 'src/hooks/use-countdown-timer';

type UsePayByBankKioskOrderSuccessModalParams = {
  onClose: () => void;
};

type UsePayByBankKioskOrderSuccessModalReturn = {
  secondsLeft: number;
  totalSeconds: number;
  handleDutchiePayOrderSuccessClose: () => void;
  progressPercentage: number;
};

export function usePayByBankKioskOrderSuccessModal({
  onClose,
}: UsePayByBankKioskOrderSuccessModalParams): UsePayByBankKioskOrderSuccessModalReturn {
  const { Cart, UI } = useStores();

  const handleDutchiePayOrderSuccessClose = useCallback(() => {
    Cart.setAnonymousOrderId('');
    Cart.setIsAnonymousKioskCheckout(false);
    UI.updateShowDutchiePayKioskOrderSuccess(false);
    onClose();
  }, [Cart, UI, onClose]);

  const totalSeconds = 8;

  const { startTimer, secondsLeft, progressPercentage } = useCountdownTimer({
    initialSeconds: totalSeconds,
    onTimerStop: handleDutchiePayOrderSuccessClose,
  });

  useEffect(() => {
    startTimer();
  }, [startTimer]);

  return {
    secondsLeft,
    totalSeconds,
    handleDutchiePayOrderSuccessClose,
    progressPercentage,
  };
}
